export class ExpandedPanel {

    constructor(private inputExpand: boolean, private outputExpand: boolean) {
    }

    public static create(): ExpandedPanel {
        return new ExpandedPanel(false, false);
    }

    public getInputExpand() {
        return this.inputExpand;
    }

    public setInputExpand(inputExpand: boolean) {
        this.inputExpand = inputExpand;
    }

    public getOutputExpand() {
        return this.outputExpand;
    }

    public setOutputExpand(outputExpand: boolean) {
        this.outputExpand = outputExpand;
    }
}